import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'

import { theme } from '../../themes/theme'
import { BoldMedBodyText } from '../styles/Text'
import { getUserInitials } from '../../util/userFormatting'

const Chip = styled(BoldMedBodyText)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: fit-content;
  height: 27px;
  border-radius: ${theme.borderRadius.button};
  background-color: ${props => props.color};
  color: ${theme.colors.text.body};
  white-space: nowrap;
`

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .MuiSvgIcon-root {
    height: 12px;
    width: 11px;
    transform: scale(1.3);
    transform-origin: center;
  }
`

const ShortChip = styled(Chip)`
  gap: 5px;
  padding: 5px 10px;
`

const ShortIconWrapper = styled(IconWrapper)`
  height: 17px;
  width: 14px;
`

const FullNameChip = styled(Chip)`
  gap: 10px;
  padding: 5px 15px;
`

const FullNameIconWrapper = styled(IconWrapper)`
  height: 17px;
  width: 15px;

  .MuiSvgIcon-root {
    height: 17px;
    width: 15px;
    transform: scale(1.2);
    transform-origin: center;
  }
`

function AssignedUserChip({
  firstName,
  lastName,
  color = theme.colors.background.light,
  isShort = false,
  showIcon = true,
  labelText = 'Assigned to'
}) {
  const hasUserName = Boolean(firstName || lastName)
  const fullName = [firstName, lastName].filter(Boolean).join(' ')
  const displayName = hasUserName ? (isShort ? getUserInitials(firstName || '', lastName || '') : fullName) : 'Removed User'
  const ChipComponent = isShort ? ShortChip : FullNameChip
  const IconWrapperComponent = isShort ? ShortIconWrapper : FullNameIconWrapper
  const shouldShowIcon = isShort || showIcon
  const ariaLabel = hasUserName ? `${labelText} ${fullName}` : `${labelText} Removed User`

  return (
    <ChipComponent color={color} aria-label={ariaLabel}>
      {shouldShowIcon && (
        <IconWrapperComponent>
          <AssignmentIndIcon aria-hidden="true" />
        </IconWrapperComponent>
      )}
      {displayName}
    </ChipComponent>
  )
}

AssignedUserChip.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  color: PropTypes.string,
  isShort: PropTypes.bool,
  showIcon: PropTypes.bool,
  labelText: PropTypes.string
}

export default AssignedUserChip
